export { default } from "./SkeletonNoteView";
